// =============================================================
// ChartCard
// -------------------------------------------------------------
// A consistent wrapper around every chart on the analytics
// dashboard. Gives the same look-and-feel across roles:
//   * Card with rounded corners and subtle shadow
//   * Header (icon + title + subtitle + optional badge/extra)
//   * Hover-elevation when the user mouses over the card
//   * Click-to-drill-down via the onClick prop
// =============================================================

import React from 'react';

export default function ChartCard({
  title,
  subtitle,
  icon,
  iconColor = '#6366f1',
  iconBg,
  badge,
  extra,
  height,            // optional explicit body height
  onClick,
  bodyStyle,
  children,
  noPadding = false,
}) {
  return (
    <div
      className="card h-100"
      style={{
        borderRadius: 14,
        border: '1px solid #e2e8f0',
        boxShadow: '0 2px 6px rgba(15,23,42,0.04)',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'box-shadow .18s ease, transform .18s ease, border-color .18s ease',
      }}
      onClick={onClick}
      onMouseEnter={onClick ? (e) => {
        e.currentTarget.style.boxShadow = `0 8px 24px ${iconColor}22`;
        e.currentTarget.style.borderColor = `${iconColor}55`;
      } : undefined}
      onMouseLeave={onClick ? (e) => {
        e.currentTarget.style.boxShadow = '0 2px 6px rgba(15,23,42,0.04)';
        e.currentTarget.style.borderColor = '#e2e8f0';
      } : undefined}
    >
      <div className="card-body" style={{ padding: noPadding ? 0 : '18px 18px 14px' }}>
        <div className="d-flex align-items-start justify-content-between gap-2 mb-3">
          <div className="d-flex align-items-center gap-2">
            {icon && (
              <div
                className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                  width: 34, height: 34,
                  background: iconBg || iconColor + '18',
                }}
              >
                <i className={`bi ${icon}`} style={{ fontSize: 16, color: iconColor }}></i>
              </div>
            )}
            <div>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#1e293b', lineHeight: 1.2 }}>
                {title}
              </div>
              {subtitle && (
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
                  {subtitle}
                </div>
              )}
            </div>
          </div>
          <div className="d-flex align-items-center gap-2 flex-shrink-0">
            {badge}
            {extra}
          </div>
        </div>
        <div style={{ minHeight: height, ...bodyStyle }}>
          {children}
        </div>
      </div>
    </div>
  );
}
